import { Injectable } from '@angular/core';
import { ApiServiceProvider } from '../api-service/api-service';

/*
  Generated class for the CheckoutServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CheckoutServiceProvider {
  constructor(public apiService: ApiServiceProvider) {}

  post(amount, email, store, brand) {
    return this.apiService.post(`/checkouts`, {
      amount,
      email,
      store,
      brand
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/checkout-service/checkout-service.ts